import { Link } from 'react-router-dom';
import type { Drama } from '@/types/drama';

interface DramaCardProps {
  drama: Drama;
  layout?: 'vertical' | 'horizontal';
}

export default function DramaCard({ drama, layout = 'vertical' }: DramaCardProps) {
  if (layout === 'horizontal') {
    return (
      <Link
        to={`/detail/${drama.id}`}
        className="group flex gap-4 rounded-lg bg-background-50 border border-background-200/70 p-3 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-24 h-36 shrink-0 overflow-hidden rounded-md bg-background-100">
          <img
            src={drama.cover}
            alt={`${drama.title}封面`}
            title={`${drama.title} 在线播放 剧情介绍`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex flex-col min-w-0 py-1">
          <h3 className="font-heading font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors truncate">
            {drama.title}
          </h3>
          <div className="flex items-center gap-2 mt-2 flex-wrap">
            <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap">
              {drama.category}
            </span>
            <span
              className={`text-[11px] px-2 py-0.5 rounded-full whitespace-nowrap ${
                drama.status === '更新中'
                  ? 'bg-accent-100 text-accent-900'
                  : 'bg-background-200 text-foreground-700'
              }`}
            >
              {drama.status}
            </span>
          </div>
          <p className="text-xs text-foreground-600 leading-relaxed mt-2 line-clamp-3">{drama.synopsis}</p>
          <span className="text-xs text-foreground-500 mt-auto pt-2">
            更新至 {drama.updatedEpisodes} / {drama.totalEpisodes} 集
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group flex flex-col rounded-lg bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={drama.cover}
          alt={`${drama.title}封面`}
          title={`${drama.title} 在线播放 剧情介绍`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span
          className={`absolute top-2 left-2 text-[11px] px-2 py-0.5 rounded-full whitespace-nowrap ${
            drama.status === '更新中'
              ? 'bg-accent-500 text-foreground-950'
              : 'bg-background-50/90 text-foreground-800'
          }`}
        >
          {drama.status}
        </span>
        <span className="absolute bottom-2 right-2 text-[11px] px-2 py-0.5 rounded-full bg-foreground-950/70 text-background-50 backdrop-blur-sm whitespace-nowrap">
          全 {drama.totalEpisodes} 集
        </span>
      </div>
      <div className="flex flex-col p-3 flex-1">
        <h3 className="font-heading font-semibold text-sm text-foreground-950 group-hover:text-primary-700 transition-colors truncate">
          {drama.title}
        </h3>
        <p className="text-xs text-foreground-600 leading-relaxed mt-1.5 line-clamp-2">{drama.synopsis}</p>
        <div className="flex items-center justify-between mt-auto pt-3">
          <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap">
            {drama.category}
          </span>
          <span className="text-[11px] text-foreground-500 whitespace-nowrap">更新 {drama.updatedEpisodes} 集</span>
        </div>
      </div>
    </Link>
  );
}